import { render } from "./AreaModalImport.vue?vue&type=template&id=1f248a1c"
import script from "./AreaModalImport.vue?vue&type=script&lang=js"
export * from "./AreaModalImport.vue?vue&type=script&lang=js"

import "./AreaModalImport.vue?vue&type=style&index=0&id=1f248a1c&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__